import helpers from './helpers';

helpers.$document
	.on('analytics-test-start', () => {
		ga('spec.send', 'event', 'test', 'start', '', {nonInteraction: true});
	})
	.on('analytics-test-question-show', (e, num, name) => {
		num = helpers.clearText(num);
		name = helpers.clearText(name).substring(0, 100);

		ga('spec.send', 'event', 'test', `question show ${num}`, name, {nonInteraction: true});
	})
	.on('analytics-test-question-answer', (e, num, name) => {
		num = helpers.clearText(num);
		name = helpers.clearText(name).substring(0, 100);

		ga('spec.send', 'event', 'test', `question answer ${num}`, name);
	})
	.on('analytics-test-finish', (e, result) => {
		result = helpers.clearText(result).substring(0, 100);

		ga('spec.send', 'event', 'test', 'finish', result);
	})
	.on('analytics-test-resume', () => {
		ga('spec.send', 'event', 'test', 'resume');
	})
	.on('click', '.test-inc-share__item', (e) => {
		const social = helpers.clearText(e.currentTarget.dataset.social);

		ga('spec.send', 'event', 'share', 'test final share', social);
	});
